import React from 'react';
import OperatorDashboard from './OperatorDashboard';

const OeeContainer = () => {
    return <OperatorDashboard />;
};

export default OeeContainer;
